import React from 'react';
import PropTypes from 'prop-types';

import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {ShopIcon} from '@amblique/king-living/app/components/icons';

/**
 * Shop Button
 * @param {Object} props
 * @param {Function} props.onClick
 */
const ShopButton = ({
  text,
  onClick,
  ...props
}) => {
  const styles = useMultiStyleConfig('ShopButton', {});

  return (
    <Box {...styles.shopButton} onClick={onClick} {...props}>
      <Box {...styles.shopIcon}>
        <ShopIcon />
      </Box>
      {text && (
        <Text {...styles.shopButtonText}>{text}</Text>
      )}
    </Box>
  );
};

ShopButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
};

export default ShopButton;
